import { useMemo, useState } from "react";
import { toast } from "react-toastify";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import {
    jenkinsfileSnippet,
    githubActionsSnippet,
    curlSnippet,
} from "./connectorSnippets";

const trimBase = (url) => (url || "").replace(/\/+$/, "");

const INTROS = {
    jenkins: "Drop this Jenkinsfile into your repo and add a Jenkins credential called beta-appstore-token holding the API token you just created.",
    gha: "Add a GitHub Actions workflow under .github/workflows/, and store the token as a repository secret named BETA_APPSTORE_TOKEN.",
    curl: "A minimal form-upload example. Export BETA_APPSTORE_TOKEN in your shell before running.",
};

const ConnectorWizard = ({ appId }) => {
    const [tab, setTab] = useState(0);

    const apiBaseUrl = trimBase(process.env.REACT_APP_API_BASEURL);

    const snippets = useMemo(
        () => ({
            jenkins: jenkinsfileSnippet({ appId, apiBaseUrl }),
            gha: githubActionsSnippet({ appId, apiBaseUrl }),
            curl: curlSnippet({ appId, apiBaseUrl }),
        }),
        [appId, apiBaseUrl],
    );

    const keys = ["jenkins", "gha", "curl"];
    const key = keys[tab];
    const snippet = snippets[key];

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(snippet);
            toast.success("Snippet copied to clipboard.");
        } catch (e) {
            toast.error("Couldn't copy to clipboard — select and copy manually.");
        }
    };

    return (
        <Stack spacing={2}>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab label="Jenkins" />
                <Tab label="GitHub Actions" />
                <Tab label="Generic curl" />
            </Tabs>

            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {INTROS[key]}
            </Typography>

            <Box
                component="pre"
                sx={{
                    bgcolor: "grey.100",
                    p: 2,
                    borderRadius: 1,
                    overflow: "auto",
                    fontSize: 13,
                    fontFamily:
                        '"SF Mono", Menlo, Consolas, "Liberation Mono", monospace',
                    m: 0,
                    whiteSpace: "pre",
                }}
            >
                {snippet}
            </Box>

            <Stack direction="row" justifyContent="flex-end">
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<ContentCopyIcon />}
                    onClick={handleCopy}
                >
                    Copy snippet
                </Button>
            </Stack>
        </Stack>
    );
};

export default ConnectorWizard;
